import React from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Variable } from '../Variable';
import { postRole } from '../../../store/Actions/ActionRolesAndPermissions';
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import { Form } from '../../../components/general/general-component/abstruct-component/AbstructForm';

function AddRole({ open, setOpen }) {

  const { mode, dispatch,langLocal } = AbstructVar();
  const { translate } = AbstructLang();
  const { state, setStateCustom, setLoad } = Variable();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(postRole(state, setLoad));
  };

  const formFields = [
    { name: 'name', label: 'name', type: 'text', inputType: 'text',iconType: "pencil" },
  ];


  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      center
      classNames={{
        modal: 'popupR',
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
        <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
          <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('add_role')}</p>
        </div>
        <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
      </div>
    </RModal>
  );
}

export default AddRole;